export default {"src":"/_next/static/media/Promotion.3b6ea1e4.svg","height":22,"width":36,"blurWidth":0,"blurHeight":0};